
import Vue, { PropType } from 'vue'
import { Connector, Project } from '../../../../../types/main'
import AudienceTitleWithParams from './AudienceTitleWithParams.vue'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'
import AutomailSettings from '../AutomailSettings.vue'
import TimeLimitsSettings from '../TimeLimitsSettings.vue'
import CustomActivatorSelect from '@root/src/components/inputs/CustomActivatorSelect.vue'
import { ActivationToEdit } from '@root/src/types/GCB2'
import TextField from '@root/src/components/inputs/TextField.vue'
import BotSettings from '../BotSettings.vue'
export default Vue.extend({
    name: 'AutomailModal',
    components: {AudienceTitleWithParams, AutomailSettings, TimeLimitsSettings, CustomActivatorSelect, TextField, BotSettings},
    props: {
        value: { type: Boolean as PropType<boolean> },
        automailSettings: { type: Object as PropType<any> },
        automailValidate: { type: Object as PropType<any> },
        activations: { type: Array as PropType<ActivationToEdit[]> },
        activationId: { type: Number as PropType<number> },
        filteredActivationsIds: {required: true, type: Array as PropType<number[]>},
        botsList: { type: Array as PropType<any[]> },
        currentActivation: { type: Object as PropType<ActivationToEdit> },
    },
    data: () => ({
        initAutomailSettings: null,
        selectedIds: [],
        initBot: null,
        activation: null,
        initActivation: null,
        selectedSettings: {
            bot: true,
            automail: true
        }
    }),
    computed: {
        isDialog: {
            get(): boolean {
                return this.value
            },
            set(value: boolean): void {
                this.$emit('input', value)
            },
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isDiff(): boolean {
            return !isEqual(this.automailSettings, this.initAutomailSettings) || !isEqual(this.activation, this.initActivation)
        },
        textFieldString(): string {
            if(this.selectedIds.length === this.filteredActivationList.length) {
                return `Выбраны все активации(${this.selectedIds.length})`
            } else {
                return `Активации(${this.selectedIds.length})`
            }
        },
        filteredActivationList(): ActivationToEdit[] {
            return this.activations.filter(el => this.filteredActivationsIds.includes(el.id))
        }
    },
    watch: {
        isDialog(val) {
            if (val) {
                this.initData()
            }            
        },
    },
    methods: {
        initData() {
            this.initAutomailSettings = cloneDeep(this.automailSettings)
            this.activation = this.activations.find(el => el.id === this.activationId)
            this.initActivation = cloneDeep(this.activation)
            // Сохраняем либо preferedBot (строка), либо sendingSettings (объект) в зависимости от isChannelsRework
            if (this.project.isChannelsRework) {
                this.initBot = this.activation.extra.sendingSettings 
                    ? cloneDeep(this.activation.extra.sendingSettings) 
                    : null
            } else {
                this.initBot = this.activation.extra.preferedBot
            }
            this.selectedIds = this.filteredActivationList.map(el => el.id)
        },
        closeAndApply() {
            if(this.selectedIds.length === 0 || (!this.selectedSettings.bot && !this.selectedSettings.automail)) {
                this.$store.dispatch('callNotify', `Не выбраны активации или настройки`)
                return
            }
            // Получаем либо preferedBot (строка), либо sendingSettings (объект) в зависимости от isChannelsRework
            const botValue = this.project.isChannelsRework
                ? (this.activation.extra.sendingSettings ? cloneDeep(this.activation.extra.sendingSettings) : null)
                : this.activation.extra.preferedBot
            this.activations.forEach(el => {
                if(this.selectedIds.includes(el.id)) {
                    if(this.selectedSettings.automail) {
                        const settings = cloneDeep(this.automailSettings)
                        el.automailSettings = settings
                        el.extra.automail = settings
                    } else if (el.id === this.activationId) {
                        this.$emit('set-val', this.activationId, this.initAutomailSettings)
                    }
                    if(this.selectedSettings.bot) {
                        if (this.project.isChannelsRework) {
                            if (botValue) {
                                el.extra.sendingSettings = cloneDeep(botValue)
                            } else {
                                delete el.extra.sendingSettings
                            }
                        } else {
                            el.extra.preferedBot = botValue
                        }
                    } else if (el.id === this.activationId) {
                        const activation = cloneDeep(el)
                        if (this.project.isChannelsRework) {
                            if (this.initActivation.extra.sendingSettings) {
                                activation.extra.sendingSettings = cloneDeep(this.initActivation.extra.sendingSettings)
                            } else {
                                delete activation.extra.sendingSettings
                            }
                        } else {
                            activation.extra.preferedBot = this.initActivation.extra.preferedBot
                        }
                        this.botChange(this.activationId, activation)
                    }
                } else if (el.id === this.activationId) {
                    this.$emit('set-val', this.activationId, this.initAutomailSettings)
                    this.botChange(this.activationId, this.initActivation)
                }
            })
            this.$emit('key-update')
            this.isDialog = false
        },
        clearAndClose() {
            if(this.isDiff) {
                this.botChange(this.activationId, this.initActivation)
                this.$emit('set-val', this.activationId, this.initAutomailSettings)
            }
            this.isDialog = false
        },
        botChange(activationId, e) {
            this.activation = e
            this.$emit('bot-change', activationId, e)
        }
    },
    mounted() {},
})
